import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/fillAccommodationBookingData', request)
}

export {post}
